import React from 'react';

import "../css/Button.css"

const Button = ({text, onClick}) => (
  <button onClick={onClick}><span>{text}</span></button>
);

export default Button;
